import React from "react";
import {Form, Label, Modal} from "semantic-ui-react";
import FirebaseUsage from "../../../firebase/firebase.usage";


export default function PasswordModal(props: {
    userEmail: string,
    setShowPasswordModal: (show: boolean) => void
}
) {
    const [email, setEmail] = React.useState(props.userEmail);
    const [password, setPassword] = React.useState("");
    const [error, setError] = React.useState<string | null>(null);

    const handleSubmit = () => {
        FirebaseUsage.useEmailAndPassword(email, password)
            .then(() => props.setShowPasswordModal(false))
            .catch((err) => setError(err.message));
    }

    return <Modal closeIcon onClose={() => props.setShowPasswordModal(false)} open={true} size="small">
        <Modal.Header>Password sign in</Modal.Header>
        <Modal.Content>
            <Form>
                <Form.Input
                    label="Email"
                    type="email"
                    value={email}
                    placeholder={props.userEmail ? null : "Enter your email"}
                    required
                    onChange={(_, data) => setEmail(data.value)}
                />
                <Form.Input
                    label="Password"
                    type="password"
                    placeholder="Enter your password"
                    required
                    onChange={(_, data) => setPassword(data.value)}
                />
                <Label>You can only sign in with a password provided by your administrator. This option is only available by request.</Label>
                {error && <Label basic color="red" pointing>Error: email or password does not match.</Label>}
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Form.Button
                primary
                disabled={!email || !password}
                onClick={handleSubmit}
            >Sign In</Form.Button>
        </Modal.Actions>
    </Modal>
}